<template>
  <b-row v-if="resource" class="px-3 px-md-5 bg-blue-50" no-gutters>
    <b-col cols="12" order="11" order-lg="0" id="scrollToElement"></b-col>
    <b-col cols="12">
      <p class="mb-2 mt-3 text-lg text-blue-500 font-weight-bold">
        {{ $t('childrenFilter.title') }}
      </p>
    </b-col>
    <b-col cols="12" class="py-2">
      <b-row no-gutters align-v="center">
        <b-col cols="auto">
          <FormCheckbox
            :model-value="openFundraising"
            @update:model-value="(evt) => (openFundraising = evt)"
            :falseValue="false"
            name="check-button"
            class="d-inline-block"
          >
            <template #label>
              <p class="mb-0 mt-1 text-blue-500">
                {{ $t('childrenFilter.label.openFundraising') }}
              </p>
            </template>
          </FormCheckbox>
        </b-col>
      </b-row>
    </b-col>
    <FilterInput
      v-model="futureProfessions"
      :limit="10"
      :label="$t('childrenFilter.label.futureProfessions')"
      :validationLabel="$t('childrenFilter.label.validationFutureProfessions')"
      showFilterInput
      :clear-filter-value="clearFilterValue"
      :options="resource.future_professions"
    ></FilterInput>
    <FilterInput
      v-model="personalDifficulties"
      :label="$t('childrenFilter.label.personalDifficulties')"
      autoHeight
      :options="resource.personal_difficulties"
    ></FilterInput>
    <FilterInput
      v-model="provinces"
      :label="$t('childrenFilter.label.provinces')"
      :options="resource.provinces"
    ></FilterInput>
    <FilterInput
      v-model="genders"
      radio
      :label="$t('childrenFilter.label.genders')"
      autoHeight
      :options="resource.genders"
    ></FilterInput>
    <FilterInput
      v-model="firstNames"
      :limit="10"
      :label="$t('childrenFilter.label.firstNames')"
      :validationLabel="$t('childrenFilter.label.validationFirstNames')"
      showFilterInput
      :clear-filter-value="clearFilterValue"
      :options="resource.first_names"
    ></FilterInput>
    <b-col cols="12" class="w-100 bg-blue-50" style="bottom: 0; position: sticky; z-index: 999">
      <b-row no-gutters>
        <b-col cols="12">
          <b-button
            id="swd_filter-button"
            @click="applyFilters"
            :disabled="getLoader"
            class="px-5 mt-3 mb-2 mx-auto d-block angle-right-icon-hover"
            variant="primary"
            size="md"
          >
            <b-spinner v-if="getLoader" class="mx-4" variant="white" small></b-spinner>
            <span v-else>
              <span>{{ $t('childrenFilter.show') }}</span>
              <span class="icon-span"> <i class="angle-right-icon ml-2 bg-white"></i></span>
            </span>
          </b-button>
        </b-col>
        <b-col cols="auto" class="mx-auto mt-0 mb-2">
          <a @click.prevent="removeAll" href="#" class="text-base text-blue">
            {{ $t('childrenFilter.clearSelected') }}
          </a>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import FilterInput from '@/components/widgets/childrenList/FilterInput.vue'
import FormCheckbox from '@/components/widgets/forms/FormCheckbox.vue'
import { createHelpers } from 'vuex-map-fields'

const { mapFields } = createHelpers({
  getterType: 'filter/getParametersField',
  mutationType: 'filter/updateParametersField'
})

export default {
  name: 'ChildrenFilter',
  components: { FilterInput, FormCheckbox },
  computed: {
    ...mapFields([
      'openFundraising',
      'futureProfessions',
      'personalDifficulties',
      'provinces',
      'genders',
      'firstNames'
    ]),
    resource() {
      return this.$store.getters['filter/getResourceFilter']
    },
    getLoader() {
      return this.$store.getters['filter/getLoader']
    }
  },
  data() {
    return {
      clearFilterValue: false
    }
  },
  methods: {
    applyFilters() {
      this.$store.commit('filter/setPagination', {
        path: 'offset',
        value: 0
      })
      this.$store.dispatch('filter/getFilter')
      document.querySelector('#scrollToElement').scrollIntoView({ behavior: 'smooth' })
    },
    removeAll() {
      this.clearFilterValue = true
      this.$store.commit('filter/setParameters')
      this.$store.commit('filter/setPagination', {
        path: 'offset',
        value: 0
      })
      document.querySelector('#scrollToElement').scrollIntoView({ behavior: 'smooth' })
      this.$store.dispatch('filter/getFilter')
      this.$nextTick(() => {
        this.clearFilterValue = false
      })
    }
  }
}
</script>
